"use client";

import { adsScript } from "@/utils/adsTempConstant";
import { useEffect } from "react";
import { useAppSelector, useState } from "@/utils/hooks/reactUseCustomHooks";
import { usePathname } from "next/navigation";

declare global {
  interface Window {
    googletag: any;
    OnetrustActiveGroups: string;
    OptanonWrapper?: () => void;
  }
}

const RmnScript: React.FC = () => {
  const [OnetrustOpt,setOnetrustOpt] = useState("");
  const observer = new MutationObserver(() => {
    const groups = window.OnetrustActiveGroups;
      setOnetrustOpt(groups);
  });
 
observer.observe(document.body, {
  childList: true,
  subtree: true,
});
  const RMN_url: string | undefined = process.env.NEXT_PUBLIC_RMN_URL;
  const selectedPath = useAppSelector((state) => state?.adsSclice.page ?? "");
  const pathname = usePathname();

  useEffect(() => {
    const hasMarketingConsent = (): boolean => {
      const activeGroups = window.OnetrustActiveGroups || "";
      return activeGroups.split(",").includes("C0004");
    };

    const initAdLoading = () => {
      if (!window.googletag?.pubads) return;

      const isPersonalized = hasMarketingConsent();

      window.googletag.cmd.push(() => {
        window.googletag
          .pubads()
          .setRequestNonPersonalizedAds(isPersonalized ? 0 : 1)
          .clear();
        window.googletag.destroySlots();

        if (
          selectedPath &&
          Array.isArray(Object.values(adsScript[selectedPath]))
        ) {
          Object.values(adsScript[selectedPath]).forEach((adSlot: any) => {
            const slot = window.googletag
              .defineSlot(adSlot.slotPath, adSlot.sizes, adSlot.id)
              .addService(window.googletag.pubads());

            if (Array.isArray(adSlot.addSize) && adSlot.addSize.length > 0) {
              const mapping = window.googletag.sizeMapping();
              adSlot.addSize.forEach((size: any) => {
                mapping.addSize(size[0], size[1]);
              });
              slot.defineSizeMapping!(mapping.build());
            }
          });

          window.googletag.pubads().enableSingleRequest();
          window.googletag.enableServices();
          window.googletag.pubads().refresh();
        }
      });
    };

    const waitForOneTrust = () => {
      if (typeof window === "undefined") return;

      if (window.OnetrustActiveGroups) {
        initAdLoading();
      } else {
        window.OptanonWrapper = () => {
          initAdLoading();
        };
      }
    };

    if (typeof window !== "undefined" && window.googletag) {
      waitForOneTrust();
    }
  }, [selectedPath, RMN_url, pathname, OnetrustOpt]);

 
  const rmnAdsScriptLoad = () => {
     if (RMN_url) {
      const script = document.createElement("script");
      script.src = RMN_url;
      script.async = true;
      document.head?.appendChild(script);
    }

    const gptScript = document.createElement("script");
    gptScript.innerHTML = `window.googletag = window.googletag || {cmd: []};`;
    document.head?.appendChild(gptScript);
  }

  useEffect(() => {
   
    rmnAdsScriptLoad();
    return () => {
      // document.head?.removeChild(gptScript);
    };
  }, [RMN_url, OnetrustOpt]);

  return null;
};

export default RmnScript;
